module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel",
    attrs: {
      "id": "page__routelist__report"
    }
  }, [_c('md-content', {
    staticClass: "md-elevation-1",
    attrs: {
      "md-theme": "white",
      "loading": _vm.progress
    }
  }, [_c('sort-table', {
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "total": _vm.reportsAmount,
      "table-id": "report-routelist",
      "default-order": "desc",
      "default-sort": "id",
      "showAddButton": false,
      "expandable": true,
      "noBreackColumns": ['traking_number', 'id'],
      "refreshOnCreate": false
    },
    on: {
      "refresh": _vm.getReports
    },
    scopedSlots: _vm._u([{
      key: "forwarder",
      fn: function(scope) {
        return [_vm._v(" " + _vm._s(scope.item.forwarder !== null ? scope.item.forwarder.login : '') + " ")]
      }
    }, {
      key: "from_stock",
      fn: function(scope) {
        return [_vm._v(" " + _vm._s(scope.item.from_stock ? scope.item.from_stock.name : 'Не установлен') + " ")]
      }
    }, {
      key: "to_stock",
      fn: function(scope) {
        return [_vm._v(" " + _vm._s(scope.item.to_stock ? scope.item.to_stock.name : 'Не установлен') + " ")]
      }
    }, {
      key: "stock",
      fn: function(scope) {
        return [_vm._v(" " + _vm._s(scope.item.stock ? scope.item.stock.name : 'Не установлен') + " ")]
      }
    }, {
      key: "date",
      fn: function(scope) {
        return [_vm._v(" " + _vm._s(scope.item.date ? _vm.moment(scope.item.date).format('DD.MM.YYYY') : 'Не установленна') + " ")]
      }
    }, {
      key: "type",
      fn: function(scope) {
        return [(parseInt(scope.item.type) === 1) ? _c('span', [_vm._v(" Экспедирование ")]) : (parseInt(scope.item.type) === 2) ? _c('span', [_vm._v(" Внутренняя перевозка ")]) : _c('span', [_vm._v(" Не указан ")])]
      }
    }, {
      key: "driver",
      fn: function(scope) {
        return [(scope.item.driver && scope.item.driver.id) ? _c('span', [_vm._v(" " + _vm._s((scope.item.driver && scope.item.driver.fio) ? scope.item.driver.fio : '') + " ")]) : _vm._e(), _vm._v(" "), (scope.item.forwarder && scope.item.forwarder.id) ? _c('span', [_vm._v(" " + _vm._s((scope.item.forwarder && scope.item.forwarder.fio) ? scope.item.forwarder.fio : '') + " ")]) : _vm._e()]
      }
    }, {
      key: "weight",
      fn: function(scope) {
        return [(scope.item.weight) ? _c('span', [_vm._v(" " + _vm._s(scope.item.weight.toFixed(2)) + " ")]) : _c('span', [_vm._v(" Не указан ")])]
      }
    }, {
      key: "size",
      fn: function(scope) {
        return [(scope.item.size) ? _c('span', [_vm._v(" " + _vm._s(scope.item.size.toFixed(2)) + " ")]) : _c('span', [_vm._v(" Не указан ")])]
      }
    }, {
      key: "status",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "itineraries-status",
          style: (('color: ' + scope.item.status.color + ';'))
        }, [_c('span', [_vm._v(" " + _vm._s(scope.item.status.message) + " ")])])]
      }
    }, {
      key: "expanded",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "can-scroll report__freigts md-table-content"
        }, [_c('table', {
          staticClass: "sort-table"
        }, [_c('thead', [_c('tr', _vm._l((_vm.itemColumns), function(column, index) {
          return _c('th', {
            key: ('th-' + index),
            staticClass: "md-table-head"
          }, [_c('div', {
            staticClass: "md-table-head-container md-ripple"
          }, [_c('div', {
            staticClass: "md-table-head-label",
            domProps: {
              "innerHTML": _vm._s(column.label)
            }
          })])])
        }))]), _vm._v(" "), (scope.item.freights) ? _c('tbody', [_vm._l((scope.item.freights), function(item, i) {
          return _c('tr', {
            key: ('tr-' + scope.item.id + '-' + i),
            staticClass: "md-table-row"
          }, _vm._l((_vm.itemColumns), function(column, index) {
            return _c('td', {
              staticClass: "md-table-cell",
              class: {
                'left-margin': !index
              }
            }, [_c('div', {
              staticClass: "md-table-cell-container"
            }, [(!(['from', 'to', 'payer', 'payment_method', 'nds'].indexOf(column.field) + 1)) ? _c('span', {
              attrs: {
                "name": column.field,
                "item": item
              }
            }, [_vm._v(" " + _vm._s(item[column.field]) + " ")]) : _vm._e(), _vm._v(" "), (column.field == 'from') ? _c('span', {
              attrs: {
                "name": column.field
              }
            }, [_vm._v(" " + _vm._s((item[column.field] && item[column.field]['value']) ? item[column.field]['value'] : '') + " ")]) : _vm._e(), _vm._v(" "), (column.field == 'to') ? _c('span', {
              attrs: {
                "name": column.field
              }
            }, [_vm._v(" " + _vm._s((item[column.field] && item[column.field]['value']) ? item[column.field]['value'] : '') + " ")]) : _vm._e(), _vm._v(" "), (column.field == 'payer') ? _c('span', {
              attrs: {
                "name": column.field
              }
            }, [_vm._v(" " + _vm._s((item[column.field] && item[column.field]['name']) ? item[column.field]['name'] : '') + " ")]) : _vm._e(), _vm._v(" "), (column.field == 'payment_method') ? _c('span', {
              attrs: {
                "name": column.field
              }
            }, [_vm._v(" " + _vm._s((item[column.field] && item[column.field]['name']) ? item[column.field]['name'] : '') + " ")]) : _vm._e(), _vm._v(" "), (column.field == 'nds') ? _c('span', {
              attrs: {
                "name": column.field
              }
            }, [_vm._v(" " + _vm._s((item.nds) ? 'Да' : 'Нет') + " ")]) : _vm._e()])])
          }))
        }), _vm._v(" "), _c('tr', {
          staticClass: "md-table-row"
        }, _vm._l((_vm.itemColumns), function(column, index) {
          return _c('td', {
            key: ('th-sum-' + index),
            staticClass: "md-table-cell"
          }, [_c('div', {
            staticClass: "md-table-cell-container"
          }, [(!(['from', 'to', 'payer'].indexOf(column.field) + 1)) ? _c('span', {
            attrs: {
              "name": column.field,
              "item": scope.item.summary
            }
          }, [_c('b', [_vm._v(" " + _vm._s(scope.item.summary[column.field]) + " ")])]) : _vm._e(), _vm._v(" "), (column.field == 'payer') ? _c('span', [_c('b', [_vm._v(" Сумма ")])]) : _vm._e()])])
        }))], 2) : _vm._e()])])]
      }
    }]),
    model: {
      value: (_vm.reports),
      callback: function($$v) {
        _vm.reports = $$v
      },
      expression: "reports"
    }
  }, [_c('template', {
    slot: "buttons"
  }, [(_vm.canPrintReport) ? _c('z-button', {
    on: {
      "click": _vm.printReport
    }
  }, [_vm._v(" Распечатать ")]) : _vm._e()], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-715b026b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/reports/views/RoutelistReport.vue
// module id = 1186
// module chunks = 0